export const inspectionReportList = ["lirrHighwayGradeCrossing", "lirrSwitchTestsAndInspection"];
export const refreshOnReturnReportList = ["lirrHighwayGradeCrossing", "lirrSwitchTestsAndInspection"];



// WEBPACK FOOTER //
// ./src/components/Reports/sims/reportFilter_SITE_Variables.js